import { regex } from '../common'

export default regex(/^[a-zA-Z]*$/)
